import { render } from "./Login2.vue?vue&type=template&id=6a707e23&scoped=true"
import script from "./Login2.vue?vue&type=script&lang=js"
export * from "./Login2.vue?vue&type=script&lang=js"

import "./Login2.vue?vue&type=style&index=0&id=6a707e23&lang=scss&scoped=true"

import exportComponent from "/root/workspace/yatinjuryplatformwebcode_Vf1x/CODE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a707e23"]])

export default __exports__